import { Loading } from "@/components/ui";
import type { ReactNode } from "react";

export interface SubmitButtonProps {
  isSubmitting: boolean;
  children: ReactNode;
  loadingLabel?: string;
  /** "button" for cards that act on click rather than submitting a form. */
  type?: "submit" | "button";
  onClick?: () => void;
}

export const SubmitButton = ({
  isSubmitting,
  children,
  loadingLabel = "Processing...",
  type = "submit",
  onClick,
}: SubmitButtonProps) => (
  <button
    className={`w-full rounded-xl bg-primary px-4 py-3.5 font-bold text-white shadow-sm transition-all duration-200 hover:bg-primary-hover focus-visible:shadow-focus ${
      isSubmitting ? "transform-none cursor-not-allowed opacity-70" : "hover:-translate-y-0.5"
    }`}
    type={type}
    onClick={onClick}
    disabled={isSubmitting}
  >
    {isSubmitting ? (
      <span className="flex items-center justify-center">
        <span className="mr-3">
          <Loading size={20} tone="inverse" fullScreen={false} />
        </span>
        {loadingLabel}
      </span>
    ) : (
      children
    )}
  </button>
);
